import { useState } from 'react';
import { Upload } from 'lucide-react';
import { Button } from '../../../ui';
import { ImportarExtratoDialog } from './ImportarExtratoDialog';

interface Props {
  companyId: string;
}

export function ImportarExtratoButton({ companyId }: Props) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="ghost" disabled={!companyId} onClick={() => setOpen(true)}>
        <Upload className="w-4 h-4 mr-1" /> Importar extrato
      </Button>
      <ImportarExtratoDialog open={open} onClose={() => setOpen(false)} companyId={companyId} />
    </>
  );
}
